package ai.wagemix.net.models

import ai.wagemix.net.WMIdentifiable
import kotlinx.serialization.Serializable

/*
select a.code, a.title, a.id, a.primary_state, t.description as type
from areas a
join area_types t
  on a.area_type_id = t.id;
 */

interface WMArea: WMIdentifiable<Int> {
    val areaType: String
    val code: String
    val name: String
    val primaryState: String
    companion object
}

fun WMArea.Companion.kxs(
    areaType: String,
    code: String,
    name: String,
    primaryState: String,
    id: Int
): KxsWMArea {
    return KxsWMArea(areaType = areaType, code = code, name = name, primaryState = primaryState, id = id)
}

fun WMArea.toKxs() = when (this) {
    is KxsWMArea -> this
    else -> WMArea.kxs(areaType = areaType, code = code, id = id, name = name, primaryState = primaryState)
}

@ConsistentCopyVisibility
@Serializable
data class KxsWMArea internal constructor(
    override val areaType: String,
    override val code: String,
    override val id: Int,
    override val name: String,
    override val primaryState: String,
): WMArea